module.exports = __webpack_public_path__ + "static/media/fondo_circense.24e882bd.jpg";